import { useSelector } from 'react-redux';
import MobileWalletsFilter from '../../../../components/MobileFilter/MobileWalletsFilter';
import MobileWalletsSort, {
  IMobileWalletsSortProps,
} from '../../../../components/MobileSort/MobileWalletsSort';
import SearchTable, {
  IMobileFilterProps,
} from '../../../../components/SearchTable/SearchTable';
import WalletWatchlistTableMobile from './WalletWatchlistTable';
import { IStore } from '../../../../reducers';
import { WalletWatchlistTab } from '../../../../reducers/wallet_watchlist';

const WalletWatchlistPanel = ({ onBack }: { onBack(): void }) => {
  const tab = useSelector((state: IStore) => state.wallet_watchlist.tab);

  const renderTable = (
    search: string,
    onChildMount: (data: IMobileFilterProps) => void,
    onBack: () => void
  ) => (
    <WalletWatchlistTableMobile
      inputSearch={search}
      onMount={onChildMount}
      onBack={onBack}
    />
  );

  const tabDependsOnChain =
    tab === WalletWatchlistTab.ActiveWallets ||
    tab === WalletWatchlistTab.BigTradesWallets;

  const renderSortOptions = (props: IMobileWalletsSortProps) => (
    <MobileWalletsSort {...props} />
  );

  const renderFilterOptions = tabDependsOnChain
    ? (props: IMobileFilterProps) => <MobileWalletsFilter {...props} />
    : undefined;

  return (
    <SearchTable
      tableTitle='Wallet Watchlist'
      sortTitle='Sorting by'
      filterTitle='Select chain'
      renderChildren={renderTable}
      renderSortOptions={renderSortOptions}
      renderFilterOptions={renderFilterOptions}
      onBack={onBack}
    />
  );
};

export default WalletWatchlistPanel;
